import { createContext } from "react";
import { AthleteStore } from "../AthletesProvider.types";

const AthleteStoreContext = createContext<AthleteStore | undefined>(undefined);
AthleteStoreContext.displayName = "AthleteStoreContext";

export default AthleteStoreContext;
